import { render, staticRenderFns } from "./vcms_cart.vue?vue&type=template&id=af8c4530"
import script from "./vcms_cart.vue?vue&type=script&lang=js"
export * from "./vcms_cart.vue?vue&type=script&lang=js"
import style0 from "./vcms_cart.vue?vue&type=style&index=0&id=af8c4530&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports